
import toastr from 'toastr';

angular.module("contact_types")

    .controller("ContactTypesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("CONTACT_TYPES_WRITE");

            $rootScope.title = $filter('translate')('contact_types.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('contact_types.title') }
            ];

            $scope.gridOptionsContactTypes = {
                pdfTitle: $filter('translate')('contact_types.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                  { name: 'name', displayName: $filter('translate')('contact_types.name'), enableFiltering: true, enableHiding: false },
                  { name: 'code', displayName: $filter('translate')('contact_types.code'), enableFiltering: true, enableHiding: false },
                  { name: 'order', displayName: $filter('translate')('contact_types.order'), enableFiltering: true, enableHiding: false },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('contact_types.button_edit'), action: 'ui-sref="contact_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('contact_types.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    return Restangular.all('ContactsTypes').getList(options).then(function(result) {
                        logService.debug(result)
                        return result;
                        });
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("contact_types.edit", { id: rowEntity.id});
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('contact_types.button_delete'),
                    message: $filter('translate')('contact_types.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('ContactsTypes', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('contact_types.deleted_success'));
                            $scope.gridOptionsContactTypes.gridApi.core.raise.itemDeleted($scope);
                        });
                    }
                });

            };

        }])

;